// src/components/settings/sections/SocialLinksSection.jsx
import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormInput from '../../inputs/FormInput';
import { getAccordionStyles } from './accordionStyles';

const SocialLinksSection = ({
    expanded,
    handleAccordionChange,
    isDark,
    formData,
    handleTextChange,
}) => {
    const { accordionBaseSx, summarySx, detailsSx } = getAccordionStyles(isDark);

    return (
        <Accordion
            expanded={expanded === 'social'}
            onChange={handleAccordionChange('social')}
            disableGutters
            elevation={0}
            square={false}
            sx={accordionBaseSx}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: isDark ? '#93C5FD' : '#1D4ED8' }} />}
                sx={summarySx}
            >
                <Typography fontWeight={600} sx={{ color: isDark ? '#E5E7EB' : '#0F172A', fontSize: 15 }}>
                    Social Links
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={detailsSx}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="facebook_url"
                            label="Facebook URL"
                            labelBio="https://facebook.com/example"
                            value={formData.facebook_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="instagram_url"
                            label="Instagram URL"
                            labelBio="https://instagram.com/example"
                            value={formData.instagram_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="twitter_url"
                            label="Twitter URL"
                            labelBio="https://twitter.com/example"
                            value={formData.twitter_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 2 }}>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="linkedin_url"
                            label="LinkedIn URL"
                            labelBio="https://linkedin.com/company/example"
                            value={formData.linkedin_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="tiktok_url"
                            label="TikTok URL"
                            labelBio="https://tiktok.com/@example"
                            value={formData.tiktok_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 220 }}>
                        <FormInput
                            type="text"
                            name="snapchat_url"
                            label="Snapchat URL"
                            labelBio="https://snapchat.com/add/example"
                            value={formData.snapchat_url}
                            onChange={handleTextChange}
                            fullWidth
                            required={false}
                        />
                    </Box>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default SocialLinksSection;
